import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import MaterialDashboard from "./material-dashboard";
import "./assets/scss/ezer.scss";
import VueTreeselect from 'vue-treeselect';
import VueCookies from 'vue-cookies'
import ToastPlugin from "vue-toast-notification";
import 'vue-toast-notification/dist/theme-bootstrap.css';
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import LoggerService from "./services/LoggerService";

// Pre-fetch IP address early so it's cached before any log calls (e.g. login)
LoggerService.prefetchIp();

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ToastPlugin);
appInstance.use(MaterialDashboard);
appInstance.use(VueTreeselect);
appInstance.use(VueCookies);
appInstance.mount("#app");
window.__app__ = appInstance.config.globalProperties;
window.__router__ = router;

// Global error handler with logging
appInstance.config.errorHandler = (err, instance, info) => {
  const message = err?.message || "Unexpected error occurred";
  
  // Show toast notification
  appInstance.config.globalProperties.$toast.error(message, {
    position: "top-right",
  });
  
  // Log the error
  LoggerService.logUIError(err, instance?.$options?.name || instance?.$options?.__name, {
    errorInfo: info,
    route: router.currentRoute.value?.fullPath,
    componentStack: instance?.$
  });
  
  // Also log to console for development
  console.error('Vue Error:', err, info);
}

// Global warning handler (optional but useful)
appInstance.config.warnHandler = (msg, instance, trace) => {
  console.warn('Vue Warning:', msg, trace);
}

// Capture unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled Promise Rejection:', event.reason);
  
  LoggerService.logUIError(
    event.reason instanceof Error ? event.reason : new Error(String(event.reason)),
    'UnhandledPromiseRejection',
    {
      promise: 'Promise rejection not handled',
      route: router.currentRoute.value?.fullPath
    }
  );
  
  // Show notification
  appInstance.config.globalProperties.$toast.error(
    'An unexpected error occurred. Please try again.',
    { position: "top-right" }
  );
});
